<template>
    <fb-list-body :pager="pager"
                  @handlePagerSizeChange="handlePagerSizeChange"
                  @handlePagerIndexChange="handlePagerIndexChange"
    >

        <template slot="btn-group">
            <el-button icon="el-icon-plus" @click="$router.push('add')">新增</el-button>
            <el-button icon="el-icon-edit" @click.stop="handleEdit">编辑</el-button>
            <el-button icon="el-icon-delete" @click.native="handleBatchDelete">删除</el-button>
            <el-button icon="el-icon-search" @click.stop="handleSearch">查询</el-button>
            <el-button icon="el-icon-upload2" @click.stop="handleImport">导入</el-button>
            <el-button icon="el-icon-download" @click.stop="handleExport">导出</el-button>
        </template>

        <template slot="search-form">

            <el-dialog
                    title="选择导入文件"
                    :visible.sync="importBoxDialogVisible"
                    width="30%"
            >

                <el-form>
                    <el-form-item label="导入文件">
                        <input ref="importFile" type="file" @change="handleImportFileChange" style="display: none">
                        {{importFile ? importFile.name:'请选择导入文件'}}<br>
                        <el-button size="small" @click="$refs.importFile.click()">选择文件</el-button>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="importBoxDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleUploadImportFile">确 定</el-button>
                </span>
            </el-dialog>


            <el-form-item class="search-form-item" label="字典名称">
                <el-input v-model="searchForm.name" placeholder="字典名称"></el-input>
            </el-form-item>

            <el-form-item class="search-form-item" label="字典标识">
                <el-input v-model="searchForm.flag" placeholder="字典标识"></el-input>
            </el-form-item>


        </template>

        <template slot="table">
            <el-table :data="tableData" @selection-change="handleSelectionChange" @row-dblclick="handleEdit">

                <el-table-column
                        type="selection"
                        width="50">
                </el-table-column>

                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>

                <el-table-column
                        prop="name"
                        label="字典名称"
                >
                </el-table-column>
                <el-table-column
                        prop="flag"
                        label="字典标识"
                >
                </el-table-column>

                <el-table-column
                        prop="description"
                        label="字典描述"
                >
                </el-table-column>


                <el-table-column
                        fixed="right"
                        label="操作"
                        width="100">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="handleEdit(scope.row)" :underline="false">编辑</el-link>
                        <el-link type="danger" @click="handleDelete(scope.row)" :underline="false"
                                 style="margin-left: 10px;">删除
                        </el-link>
                    </template>
                </el-table-column>


            </el-table>
        </template>


    </fb-list-body>
</template>

<script>
    export default {
        name: "DictList",
        props: {
            timestamp: {
                type: Number, default: function () {
                    return new Date().getTime()
                }
            },
        },
        data() {
            return {
                api: {
                    list: this.$api.dictType.list,
                    delete: this.$api.dictType.delete,
                    batchDelete: this.$api.dictType.batchDelete,
                },
                importFile: null,
                importBoxDialogVisible: false,
                searchForm: {account: '', nickname: '', mobile: '', email: ''},
                tableData: [],
                selection: [],
                pager: {
                    pageSize: 10
                    , pageIndex: 1,
                    itemCount: 0
                }
            }
        },
        computed: {
            searchParams() {
                return Object.assign({}, this.$route.query, this.searchForm, this.pager);
            }
        },
        watch: {
            timestamp() {
                this.handleSearch();
            },
            "pager.pageIndex":{
                handler() {
                    this.$router.updateQuery({path: this.$route.path, query: this.searchParams});
                    this.handleSearch();

                },
                deep:true,
                immediate:true
            },
            "pager.pageSize":{
                handler() {

                    this.$router.updateQuery({path: this.$route.path, query: this.searchParams});
                    this.handleSearch();

                },
                deep:true
            }
        },
        methods: {
            handleImportFileChange(e) {
                this.importFile = this.$refs['importFile'].files[0];
            },
            handleUploadImportFile() {

                let vm =this;

                if (!this.importFile) {
                    this.$message({type: 'ERROR', message: '未选择导入文件'});
                }

                let formData = new FormData();
                formData.append("file",this.importFile);

                this.$http.post(this.$api.dictType.importDict, formData, {headers: {"Content-Type": "multipart/form-data"},}).then((resp) => {

                    if (resp.data.status === 200) {
                        vm.$message({type: 'success', message: resp.data.desc});
                        vm.handleSearch();
                        vm.importBoxDialogVisible=false;
                    } else {
                        vm.$message({type: 'error', message: resp.data.desc});

                    }

                });
            },

            handleExport() {
                window.open(this.$api.dictType.exportDict);
            },
            handleImport() {
                this.importBoxDialogVisible = true;
            },
            handleEdit(e) {

                if (e && e.code) {
                    this.$router.push({path: 'edit', query: {code: e.code}});
                    return;
                }

                if (!this.selection.length) {
                    this.$message({type: 'warning', message: '未选择记录'});
                    return;
                }

                if (this.selection.length > 1) {
                    this.$message({type: 'warning', message: '一次只能编辑一条数据'});
                    return;
                }

                this.$router.push({path: 'edit', query: {code: this.selection[0].code}});
            },

            handleBatchDelete(row) {


                let vm = this;

                vm.$confirm('您现在正在进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(vm.api.delete, vm.$qs.stringify({code: row.code})).then((resp) => {
                        if (resp.data.status === 200) {
                            vm.$message({type: 'success', message: resp.data.desc});
                            vm.handleSearch();
                        } else {
                            vm.$message({type: 'error', message: resp.data.desc});

                        }
                    })


                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

            },

            handleDelete(row){


                let vm = this;

                vm.$confirm('您现在正在进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(vm.api.delete,vm.$qs.stringify({code:row.code})).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.handleSearch();
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

            },

            handleSelectionChange(selection) {
                console.log(selection);
                this.selection = selection;
            },
            handlePagerSizeChange(e) {
                this.pager.pageSize = e;
            },
            handlePagerIndexChange(e) {
                this.pager.pageIndex = e;
            },
            handleSearch() {
                let vm = this;
                this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


                    for (let key in resp.data.data) {
                        if (resp.data.data[key] instanceof Array) {
                            vm.tableData = resp.data.data[key];
                        }
                    }

                    //处理分页
                    vm.pager.pageIndex = resp.data.data.pager.pageIndex;
                    vm.pager.pageSize = resp.data.data.pager.pageSize;
                    vm.pager.itemCount = resp.data.data.pager.itemCount;

                })
            }
        },
        created() {
            for (let key in this.searchForm) {
                if (this.$route.query[key]) {
                    this.searchForm[key] = this.$route.query[key];
                }
            }
        }
    }
</script>

<style scoped>

</style>
